<div class="translation-fields-container">
  <app-recipes-translation-field
    class="grow"
    [fieldOptions]="{
      control: fieldsOptions.sourceControl.left,
      label: fieldsOptions.label,
      size: fieldsOptions.size,
      placeholder: fieldsOptions.placeholder,
      requiredTranslationKey: fieldsOptions.fieldName?.left
    }"
  />

  <app-recipes-translation-field
    class="grow"
    *ngIf="fieldsOptions.sourceControl.right"
    [fieldOptions]="{
      control: fieldsOptions.sourceControl.right,
      label: fieldsOptions.label,
      size: fieldsOptions.size,
      placeholder: fieldsOptions.placeholder,
      requiredTranslationKey: fieldsOptions.fieldName?.right
    }"
  />

  <mat-icon>chevron_right</mat-icon>
  <app-recipes-translation-field
    class="grow"
    [fieldOptions]="{
      control: fieldsOptions.targetControl.left,
      label: fieldsOptions.label,
      size: fieldsOptions.size,
      placeholder: fieldsOptions.placeholder,
      requiredTranslationKey: fieldsOptions.fieldName?.left
    }"
  />

  <app-recipes-translation-field
    class="grow"
    *ngIf="fieldsOptions.targetControl.right"
    [fieldOptions]="{
      control: fieldsOptions.targetControl.right,
      label: fieldsOptions.label,
      size: fieldsOptions.size,
      placeholder: fieldsOptions.placeholder,
      requiredTranslationKey: fieldsOptions.fieldName?.right
    }"
  />
</div>
